/* eslint-disable jsx-a11y/scope */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import makeAnimated from 'react-select/animated'
import Select from 'react-select'
const CPDataUpdate = ({ ...props }) => {
    const [load, setload] = useState(true)
    const [Qualifi, setQualifi] = useState("")
    const [Level3, setLevel3] = useState("")
    const [Group3, setGroup3] = useState("")
    const [State, setState] = useState([])
    const [Field, setField] = useState("")
    const [Branch, setBranch] = useState([])
    const [Level, setLevel] = useState([])
    const [formData, setFormData] = useState({
        CpdetailsId: Number(props.CpdetailsId),
        Nameoftheemployer1: "",
        Designationofposts2: "",
        Group3: "",
        Level4: "",
        FieldBranch5: "",
        Qualification6: "",
        Experience7: "",
        Noofvacancies8: "0",
        Employercategory9: "",
        Nameofthestate10: "",
        Jobname11: "",
        EmploymentId: Number(props.employmentId),
        ParametersId: Number(props.parametersId)
        
    });

    const getdata = async () => {
        
        const sendData = {
            CpdetailsId: Number(props.CpdetailsId),

        }
         //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/CP/GetCP1Details', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    const maindata = data[0]
                   //console.log(maindata)
                    setFormData({
                        Nameoftheemployer1: maindata.nameoftheemployer1,
                        Designationofposts2: maindata.designationofposts2,
                        Group3: maindata.group3,
                        Level4: maindata.level4,
                        FieldBranch5: maindata.fieldBranch5,
                        Qualification6: maindata.qualification6,
                        Experience7: maindata.experience7,
                        Noofvacancies8: maindata.noofvacancies8,
                        Employercategory9: maindata.employercategory9,
                        Nameofthestate10: maindata.nameofthestate10,
                        Jobname11: maindata.jobname11,
                        CpdetailsId: Number(props.CpdetailsId)
                    });
                    setload(false)
                })


    };
    const onInputChange = async (e) => {
        ////console.log((e.target.value))
        e.target.value < 0 ? e.target.value = null : String(e.target.value)
        setFormData({ ...formData, [e.target.name]: String(e.target.value) });
        const sendData = {
            ...formData, [e.target.name]: String(e.target.value)
        }
        ////console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/CP/UpdateDetailsCP1', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                maindata => {
                    //console.log(maindata)
                    setFormData({
                        Nameoftheemployer1: maindata.nameoftheemployer1,
                        Designationofposts2: maindata.designationofposts2,
                        Group3: maindata.group3,
                        Level4: maindata.level4,
                        FieldBranch5: maindata.fieldBranch5,
                        Qualification6: maindata.qualification6,
                        Experience7: maindata.experience7,
                        Noofvacancies8: maindata.noofvacancies8,
                        Employercategory9: maindata.employercategory9,
                        Nameofthestate10: maindata.nameofthestate10,
                        Jobname11: maindata.jobname11,
                        CpdetailsId: Number(props.CpdetailsId)

                    });
                    setload(false)
                })
        props.setGTotal(props.GTotal + 1)
    };

    const getState = async () => {
        const sendData = {
            CatgId: Number(43),

        }
        /*//console.log(sendData)*/

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/Getstate2', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    ////console.log(data)
                    setState(data)
                })


    };

    const getbranchdata = async () => {
        const sendData = {
            CatgId: Number(Field)
        }
        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/GetDetailsValueM', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                   // console.log(data)
                    if (data.length > 0) {
                        setBranch(data)
                    }
                })


    };

    const getLeveldata = async () => {
        const sendData = {
            CatgId: Number(57)
        }
        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/GetDetailsValueM', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    // console.log(data)
                    if (data.length > 0) {
                        setLevel(data)
                    }
                })


    };

    useEffect(() => {
        getdata()
        getState()
    }, [props.Change, props.edit])

    useEffect(() => {
        getbranchdata()
        getLeveldata()
    }, [Field])

    //console.log(formData)
    //check empty
    useEffect(() => {
        if (formData.Nameoftheemployer1 === null || formData?.Nameoftheemployer1.trim() === "" || formData.Designationofposts2 === null || formData?.Designationofposts2.trim() === ""
            || formData.Group3 === null || formData?.Group3 === "" || formData.Group3 === "none" || formData.Level4 === null || formData?.Level4 === "" || formData.Level4 === "none"
            || formData.FieldBranch5 === null || formData?.FieldBranch5 === "" || formData.FieldBranch5 === "none" || formData.Qualification6 === null || formData?.Qualification6 === "" || formData.Qualification6 === "none"
            || formData.Experience7 === null || formData?.Experience7 === "" || formData.Experience7 === "none" || formData.Noofvacancies8 === null || formData?.Noofvacancies8 === ""
            || formData.Employercategory9 === null || formData?.Employercategory9 === "" || formData.Employercategory9 === "none" || formData.Nameofthestate10 === null || formData?.Nameofthestate10 === "" || formData.Nameofthestate10 === "none"
            || formData.Jobname11 === null || formData?.Jobname11 === "" || formData.Jobname11 === "none" 
            
            ) {
            props.setform(true)
        } else {
            props.setform(false)
        }
    }, [formData])
   // console.log(formData)
    const inputHandler = (e) => {
        const { value, maxLength } = e.target;
        if (String(value).length >= maxLength) {
            e.preventDefault();
            return;
        }
    };
    const Qulifichange = (e) => {
        if (e.target.value === "Other") {
            setQualifi(e.target.value)
        } else {
            setQualifi("")
            onInputChange(e)
        }
    }

    const Levelchange = (e) => {
        if (e.target.value === "Other") {
            setLevel3(e.target.value)
        } else {
            setLevel3("")
            onInputChange(e)
        }
    }

    const Goup3change = (e) => {
        if (e.target.value === "Other") {
            setGroup3(e.target.value)
        } else {
            setGroup3("")
            onInputChange(e)
        }
    }
   


    return (
        load ? null :
            <tr scope="row" key={props.keyy } >

                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.value}

                </td>

                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="text"
                        min="0"
                        id="Nameoftheemployer1"
                        className="form-control" maxLength="30" onKeyPress={inputHandler}
                        name="Nameoftheemployer1"
                        style={{ textAlign: 'center' }}
                        onChange={(e) => onInputChange(e)}
                        onKeyUp={(evt) => evt.key === 'x'}
                        onKeyDown={(evt) => (evt.keyCode > 64 && evt.keyCode < 96) || (evt.keyCode > 0 && evt.keyCode < 33) || evt.preventDefault()}
                        defaultValue={formData.Nameoftheemployer1}
                    /> : formData.Nameoftheemployer1}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="text"
                        min="0"
                        id="Designationofposts2"
                        className="form-control" maxLength="30" onKeyPress={inputHandler}
                        name="Designationofposts2"
                        style={{ textAlign: 'center' }}
                        onKeyDown={(evt) => (evt.keyCode > 64 && evt.keyCode < 96) || (evt.keyCode > 0 && evt.keyCode < 33) || evt.preventDefault()}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        defaultValue={formData.Designationofposts2}
                    /> : formData.Designationofposts2}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ?  <select
                            className="form-control form-select"
                            name="Group3"
                            id="Group3"
                            onChange={(e) => Goup3change(e)}
                        >
                            <option value="none" selected disabled>{formData.Group3 === "" || formData.Group3 === null ? "Select" : formData.Group3} </option>
                            <option value="A" > A</option>
                            <option value="B" > B</option>
                            <option value="C" > C</option>
                            <option value="Other" > Other (....)</option>
                    </select> : formData.Group3}
                    {Group3 === "Other" ? <input
                        type="text"
                        min="0"
                        id="Group3"
                        className="form-control" maxLength="25" onKeyPress={inputHandler}
                        name="Group3"
                        style={{ textAlign: 'center' }}
                        onKeyDown={(evt) => (evt.keyCode > 64 && evt.keyCode < 96) || (evt.keyCode > 0 && evt.keyCode < 33) || (evt.keyCode > 47 && evt.keyCode < 58) || evt.preventDefault()}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        defaultValue={formData.Group3}
                    /> : null}


                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <select
                        className="form-control form-select"
                        name="Level4"
                        id="Level4"
                        onChange={(e) => Levelchange(e)}
                    >
                        <option value="none" selected disabled>{formData.Level4 === "" || formData.Level4 === null ? "Select" : formData.Level4} </option>
                        {Level.length > 0 ? Level.map((details, index) =>
                            <option value={`${details.catgDesc}`} > {details.catgDesc}</option>

                        ) : null}
                        <option value="Other" > Others (....)</option>
                    </select> : formData.Level4}
                    {Level3 === "Other" ? <input
                        type="text"
                        min="0"
                        id="Level4"
                        className="Level4-control" maxLength="25" onKeyPress={inputHandler}
                        name="Level4"
                        style={{ textAlign: 'center' }}
                        onKeyDown={(evt) => (evt.keyCode > 64 && evt.keyCode < 96) || (evt.keyCode > 0 && evt.keyCode < 33) || (evt.keyCode > 47 && evt.keyCode < 58) || evt.preventDefault()}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        defaultValue={formData.Level4}
                    /> : null}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ?<select
                            className="form-control form-select"
                            name="FieldBranch"
                            id="FieldBranch"
                            onChange={(e) => setField(e.target.value)}
                        >
                            <option value="none" selected disabled>{formData.FieldBranch5 === "" || formData.FieldBranch5 === null ? "Select" : formData.FieldBranch5} </option>
                            <option value="50" > Engineering(GT-1)</option>
                            <option value="51" > Technology(GT-2)</option>
                            <option value="52" > Agriculture(GT-3)</option>
                            <option value="53" > Medicine(GT-4)</option>
                            <option value="54" > Natural Science(GT-5)</option>
                            <option value="55" > Social Science including Teaching(GT-6)</option>
                        <option value="56" > Miscellaneous Graduates(GT-7)</option>
                    </select> : formData.FieldBranch5}

                    {Field.length > 0 ?
                        <>
                        <h5>Select Branch</h5>
                        <select
                            className="form-control form-select"
                            name="FieldBranch5"
                            id="FieldBranch5"
                            onChange={(e) => onInputChange(e)}
                        >
                            <option value="none" selected disabled>{formData.FieldBranch5 === "" || formData.FieldBranch5 === null ? "Select" : formData.FieldBranch5} </option>
                            {Branch.length > 0 ? Branch.map((details, index)=>
                                <option value={`${details.catgDesc}`} > {details.catgDesc}</option>
                            ) : null}
                            </select></> : null}

                    {/*<input
                        type="text"
                        min="0"
                        id="FieldBranch5"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="FieldBranch5"
                        style={{ textAlign: 'center' }}
                        onKeyDown={(evt) => (evt.keyCode > 64 && evt.keyCode < 96) || (evt.keyCode > 0 && evt.keyCode < 33) || (evt.keyCode > 47 && evt.keyCode < 58) || evt.preventDefault()}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        defaultValue={formData.FieldBranch5}
                    /> */}

                </td>

                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ?
                        <select
                            className="form-control form-select"
                            name="Qualification6"
                            onChange={(e) => Qulifichange(e)}
                        >

                            <option value="none" selected disabled>{formData.Qualification6 === "" || formData.Qualification6 === null ? "Select" : formData.Qualification6} </option>
                            <option value="8" > 8th</option>
                            <option value="10" > 10th</option>
                            <option value="12" > 12th</option>
                            <option value="ITI" > ITI</option>
                            <option value="diploma" > Diploma</option>
                            <option value="gradute" > Graduate</option>
                            <option value="postgraduate" > Post Graduate</option>
                            <option value="phd" > PhD</option>
                            <option value="Other" > Others (....)</option>
                        </select> : formData.Qualification6}
                    {Qualifi === "Other" ? <input
                        type="text"
                        min="0"
                        id="Qualification6"
                        className="form-control" maxLength="25" onKeyPress={inputHandler}
                        name="Qualification6"
                        style={{ textAlign: 'center' }}
                        onKeyDown={(evt) => (evt.keyCode > 64 && evt.keyCode < 96) || (evt.keyCode > 0 && evt.keyCode < 33) || (evt.keyCode > 47 && evt.keyCode < 58) || evt.preventDefault()}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        defaultValue={formData.Qualification6}
                    /> : null}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ?
                        <select
                            className="form-control form-select"
                            name="Experience7"
                            onChange={(e) => onInputChange(e)}
                        >
                            <option value="none" selected disabled>{formData.Experience7 === "" || formData.Experience7 === null ? "Select" : formData.Experience7} </option>
                            <option value="withexperience" > With Experience</option>
                            <option value="withoutexperience" > Without Experience</option>
                        </select> : formData.Experience7}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth:"150px" }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Noofvacancies8"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="Noofvacancies8"
                        style={{ textAlign: 'center' }}
                        onFocus={(e) => e.target.value === 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value === '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Noofvacancies8}
                    /> : formData.Noofvacancies8}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ?
                        <select
                            className="form-control form-select"
                            name="Employercategory9"
                            onChange={(e) => onInputChange(e)}
                        >
                            <option value="none" selected disabled>{formData.Employercategory9 === "" || formData.Employercategory9 === null ? "Select" : formData.Employercategory9} </option>
                            <option value="CG" > Central Govt.</option>
                            <option value="SG" > State Govt.</option>
                            <option value="QG" > Quasi Govt.</option>
                            <option value="LB" > Local Bodies</option>
                            <option value="Pv" > Private Sector</option>
                        </select> : formData.Employercategory9}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <select
                        className="form-control form-select"
                        name="Nameofthestate10"
                        onChange={(e) => onInputChange(e)}
                    >
                        <option value="none" selected disabled>{formData.Nameofthestate10 === "" || formData.Nameofthestate10 === null ? "Select" : formData.Nameofthestate10} </option>
                        {State.map((sdata, index) => <option key={index} value={sdata.catgType} >{sdata.catgType}</option>)} 
                    </select> : formData.Nameofthestate10 }
                  
                   
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ?
                        <select
                            className="form-control form-select"
                            name="Jobname11"
                            onChange={(e) => onInputChange(e)}
                        >
                            <option value="none" selected disabled>{formData.Jobname11 === "" || formData.Jobname11 === null ? "Select" : formData.Jobname11} </option>
                            <option value="Regular" > Regular</option>
                            <option value="Temporary" > Temporary</option>
                            <option value="Contractual" > Contractual</option>
                            <option value="Deputation" > Deputation</option>
                        </select> : formData.Jobname11}
                   

                </td>
              

            </tr>
    );
};

export default CPDataUpdate;
